import { APP_STORE_URL, PLAY_STORE_URL } from "./nativeAppReleaseConstants";

const STORAGE_KEY_VERSION = "v1";

/** 表示判定に使う勤務完了 1 件分（報酬確定モーダル 1 件に対応） */
export type AppReviewRequestWorkCompletion = {
  isWorkersCompensation: boolean;
  isFirstActualWorkCompleted: boolean;
};

export type AppReviewStorePlatform = "ios" | "android" | "other";

export const buildAppReviewRequestDialogStorageKey = (
  workerId: string,
): string => `${STORAGE_KEY_VERSION}:appReviewRequestDialog:${workerId}`;

/** 「今後表示しない」が保存済みか。読み取れない場合は表示しない側（true）に倒す */
export function isAppReviewRequestDialogDismissed(workerId: string): boolean {
  if (typeof window === "undefined") return true;

  try {
    return (
      localStorage.getItem(buildAppReviewRequestDialogStorageKey(workerId)) ===
      "true"
    );
  } catch {
    return true;
  }
}

export function markAppReviewRequestDialogDismissed(
  workerId: string | undefined,
): void {
  if (!workerId) return;

  try {
    localStorage.setItem(
      buildAppReviewRequestDialogStorageKey(workerId),
      "true",
    );
  } catch (error) {
    console.warn("Failed to write to localStorage:", error);
  }
}

/**
 * 1 回の表示機会（報酬確定モーダルのキュー全体）でレビュー依頼ダイアログを出すか。
 * - 利用停止中・退会済み、非表示設定済みは出さない
 * - 初回の勤務完了（休業補償を除く）が 1 件でも含まれる場合は出さない
 * - 全件が休業補償の場合は出さない
 */
export function shouldShowAppReviewRequestDialog({
  workerId,
  workerStatus,
  completions,
}: {
  workerId: string | undefined;
  workerStatus: string | undefined;
  completions: AppReviewRequestWorkCompletion[];
}): boolean {
  if (!workerId || workerStatus !== "enabled") return false;
  if (completions.length === 0) return false;
  if (isAppReviewRequestDialogDismissed(workerId)) return false;
  if (completions.some((c) => c.isFirstActualWorkCompleted)) return false;
  return completions.some((c) => !c.isWorkersCompensation);
}

export function detectAppReviewStorePlatform(
  userAgent: string,
): AppReviewStorePlatform {
  if (/iPhone|iPad|iPod/i.test(userAgent)) return "ios";
  if (/Android/i.test(userAgent)) return "android";
  return "other";
}

export function getAppReviewStoreUrl(
  platform: Exclude<AppReviewStorePlatform, "other">,
): string {
  return platform === "ios" ? APP_STORE_URL : PLAY_STORE_URL;
}
